import classNames from 'classnames';
import * as dateFns from 'date-fns';
const { differenceInYears, format } = dateFns;
import { isUndefined } from 'lodash-es';
import * as React from 'react';
import StringUtils from '../../../../components/utils/StringUtils';
import StarRating from '../../../../atoms/icons/StarRating';
import css from './Review.module.scss';

import { MerchantReview } from '../../../../interfaces/merchants/reviews';

interface Props {
  className?: string;
  review: MerchantReview;
}

const Review = ({ className, review }: Props) => {
  const classes = classNames(css.Review, className);
  const age = review.birthday
    ? differenceInYears(new Date(), new Date(review.birthday * 1000))
    : 0;
  const displayAge = age < 20 ? '10代以下' : `${Math.floor(age / 10) * 10}代`;
  const replyDate =
    review.reply && review.reply.updated_at
      ? new Date(review.reply.updated_at * 1000)
      : new Date();

  return (
    <li className={classes}>
      <div className={css.Review__Header}>
        <p className={css.Review__Customer}>
          <span className={css.Review__CustomerName}>
            {review.name === 'Anonymous' ? '匿名のユーザー' : review.name}
          </span>
          {review.gender && (
            <span className={css.Review__CustomerGender}>
              {` ${review.gender === 'female' ? '女性' : '男性'}`}
            </span>
          )}
          {review.birthday && (
            <span
              className={css.Review__CustomerAge}
            >{` | ${displayAge}`}</span>
          )}
        </p>
        {!isUndefined(review.rating) && (
          <StarRating className={css.Review__StarRating} rate={review.rating} />
        )}
      </div>
      {review.comment && (
        <div className={css.Review__Body}>
          {StringUtils.simpleFormat(review.comment)}
        </div>
      )}
      <div className={css.Review__Footer}>
        <p className={css.Review__Date}>
          {format(new Date(review.updated_at * 1000), 'YYYY年MM月DD日')}
        </p>
      </div>
      {review.reply && (
        <div className={css.Review__Reply}>
          <b className={css.Review__ReplyLabel}>返信コメント</b>
          {StringUtils.simpleFormat(review.reply.comment)}
          <span className={css.Review__ReplyDate}>
            {format(replyDate, 'YYYY年MM月DD日')}
          </span>
        </div>
      )}
    </li>
  );
};

export default Review;
